export default {
  'table.total': 'Всего: {{amount}} элементов',
  'table.actions': 'Действия',
};
